var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"distributor-storage"},[_c('user-info-header'),_c('div',{staticClass:"distributor-storage__wrap"},[(_vm.$route.meta.title)?[_c('h1',[_vm._v(_vm._s(_vm.$route.meta.title))])]:_vm._e(),_c('transition',{attrs:{"name":"component-fade","mode":"out-in"}},[_c('router-view')],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }